import { render, staticRenderFns } from "./broadxl.vue?vue&type=template&id=44f93614&scoped=true"
import script from "./broadxl.vue?vue&type=script&lang=js"
export * from "./broadxl.vue?vue&type=script&lang=js"
import style0 from "./broadxl.vue?vue&type=style&index=0&id=44f93614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f93614",
  null
  
)

export default component.exports